var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader-wrapper"},[_c('div',{ref:"container",staticClass:"loader-container"},[_c('div',{ref:"loader",staticClass:"loader"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }